import { TopSection } from "src/components/_pages/faq/top-section";
import { TextSection } from "src/components/_pages/faq/text-section";
import { Footer } from "src/components/footer";

const Faq = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | FAQ</title>
      <article>
        <TopSection />
        <TextSection />
        <Footer />
      </article>
    </>
  );
};

export default Faq;
